export default __webpack_public_path__ + "static/media/pakk3.86d77514.jpg";